import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from 'chameleon/ui-stack/ui/base/button';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';

const RemoveQuestionAction = (props) => {
  const {
    featureFlag: { icon_preview_update: iconPreviewUpdateFlag },
    subjectData: { isPreApSubject },
    onDeleteClick,
    ariaLabel,
    disabled,
  } = props;
  const showIcons = !isPreApSubject && iconPreviewUpdateFlag;

  return (
    <Fragment>
      {(showIcons && (
        <ButtonWithIcon
          isNaked
          isIcon
          icon="delete_question"
          aria-label={ariaLabel}
          onClick={onDeleteClick}
          tabIndex={0}
          disabled={disabled}
        />
      )) || (
        <Button
          isDanger
          accessibility={{
            label: 'Remove',
          }}
          onClick={onDeleteClick}
          disabled={disabled}
        >
          Remove
        </Button>
      )}
    </Fragment>
  );
};

RemoveQuestionAction.propTypes = {
  onDeleteClick: PropTypes.func,
  ariaLabel: PropTypes.string.isRequired,
};

RemoveQuestionAction.defaultProps = {
  onDeleteClick: () => {},
};

const mapStateToProps = (state) => {
  const { featureFlag, subject } = state;
  return {
    featureFlag,
    subjectData: subject.data,
  };
};
export default connect(mapStateToProps)(RemoveQuestionAction);
